import { Box, Typography, Button } from '@mui/material';
import { Delete as DeleteIcon, Add as AddIcon } from '@mui/icons-material';
import { CustomButton } from '../../../../../../../Infra/CustomButton/CustomButton';
import { CustomAutocomplete } from '../../../../../../../Infra/CustomAutocomplete/CustomAutocomplete';
import { useColumnMapping } from './useColumnMapping';
import { ColumnMappingProps } from './types';
import { ColumnMapping as ColumnMappingType } from '../../../../../types';
import './ColumnMapping.scss';

export const ColumnMapping = (props: ColumnMappingProps) => {
  const {
    columnMappings,
    availableColumns,
    getAvailableColumnsForMapping,
    handleAddColumn,
    handleRemoveColumn,
    handleColumnChange,
    singleMode,
  } = useColumnMapping(props);

  // Helper to get columns for a specific mapping (includes current selection)
  const getColumnsForDropdown = (mapping: ColumnMappingType): string[] => {
    const filteredColumns = getAvailableColumnsForMapping(mapping.id);

    // Always include the currently selected column (if it exists)
    if (
      mapping.sourceColumn &&
      !filteredColumns.includes(mapping.sourceColumn)
    ) {
      return [mapping.sourceColumn, ...filteredColumns];
    }

    return filteredColumns;
  };

  return (
    <Box className={`columnMapping ${singleMode ? 'singleMode' : ''}`}>
      <Typography variant="subtitle2" sx={{ textAlign: 'left', mb: 1.5 }}>
        COLUMN MAPPING
      </Typography>

      {singleMode ? (
        // Single mode: just one dropdown, no buttons
        columnMappings.length > 0 && (
          <Box className="mappingRows">
            <Box className="mappingRow singleMode">
              <CustomAutocomplete
                value={columnMappings[0].sourceColumn || null}
                onChange={(_, newValue) =>
                  handleColumnChange(columnMappings[0].id, newValue || '')
                }
                options={availableColumns}
                placeholder="Select column"
                ListboxProps={{
                  style: { maxHeight: 300 },
                }}
                className="columnSelect"
              />
            </Box>
          </Box>
        )
      ) : (
        // Multi-column mode: always show mapping rows
        <Box className="mappingRows">
          {columnMappings.map((mapping, index) => (
            <Box key={mapping.id} className="mappingRow">
              <CustomAutocomplete
                value={mapping.sourceColumn || null}
                onChange={(_, newValue) =>
                  handleColumnChange(mapping.id, newValue || '')
                }
                options={getColumnsForDropdown(mapping)}
                placeholder="Select column"
                ListboxProps={{
                  style: { maxHeight: 300 },
                }}
                className="columnSelect"
              />

              {columnMappings.length > 1 && (
                <CustomButton
                  className="deleteButton"
                  variant="outlined"
                  color="error"
                  onClick={() => handleRemoveColumn(mapping.id)}
                  size="small"
                  sx={{ minWidth: '40px', padding: '6px 12px' }}
                >
                  <DeleteIcon fontSize="small" />
                </CustomButton>
              )}

              {/* Show ADD COLUMN button on last row */}
              {index === columnMappings.length - 1 && (
                <Button
                  variant="outlined"
                  startIcon={<AddIcon />}
                  onClick={handleAddColumn}
                  className="addColumnButton"
                >
                  ADD COLUMN
                </Button>
              )}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};
